import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import Button from '@/components/common/Button';

import styles from './LogoutModal.module.scss';

export interface LogoutModalProps {
  onDismiss: (doLogout?: boolean) => void;
}

export default function LogoutModal({
  onDismiss,
}: LogoutModalProps) {
  return (
    <div id="bottom-modal-logout" className={styles.container}>
      <div className={styles.closeButton}>
        <IonIcon
          id="button-close-logout-modal"
          icon={closeOutline}
          onClick={() => onDismiss()}
        />
      </div>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <p className={styles.title}>¡Vuelve cuando quieras!</p>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            id="button-logout"
            onClick={() => onDismiss(true)}
          >
            Cerrar sesión
          </Button>
          <Button
            id="button-logout-return"
            fill="outline"
            onClick={() => onDismiss()}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}
